import React from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import Navbar from '../../../../_components/common/Navbar';
import SideNavBar from '../../../../_components/common/SideNavBar'
import { superAdminAreaData } from '../../OrgAdminArea/SidebarData'
import UtilityNav from '../../../../_components/common/UtilityNav'
import ModalComponent from '../../../../_components/common/Modal';
import { Table } from 'reactstrap';
import TableNew from '../../../../_components/common/Table';
import { reviewQuestionsContext } from './formData'
import { superAdminAction } from '../../../../_actions';

class ReviewQuestionsContext extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            reviewQuestionsModal: false,
            reviewDetails: null,
            updateMessage: false,
            textType: 1,
            navData: [],
        }
    }

    componentDidUpdate(prevProp) {
        if(prevProp.headPerLoadingResonse !== this.props.headPerLoadingResonse) {
            if(this.props.headPerLoadingResonse !== '') {
                const temp = []
                if(localStorage.getItem("is_pa_user") == "true") {
                    temp.push({
                        navName: "Analyze",
                        link: `/organisation/${this.props.match.params.id}/user`
                    })
                }
                if(localStorage.getItem("is_org_admin") == "true") {
                    temp.push({
                        navName: "Org Admin Area",
                        link: `/organisation/${this.props.match.params.id}/org-admin`
                    })
                }
                if(localStorage.getItem("is_success") == "true") {
                    temp.push({
                        navName: "Super Admin Area",
                        link: `/organisation/${this.props.match.params.id}/super-admin`
                    })
                }
                this.setState({navData: temp})
            }
        }
    }

    componentDidMount() {
        this.props.dispatch(superAdminAction.getReviewQuestionsHandler(this.state.textType, () => { }))
        const temp = []
        if(localStorage.getItem("is_pa_user") == "true") {
            temp.push({
                navName: "Analyze",
                link: `/organisation/${this.props.match.params.id}/user`
            })
        }
        if(localStorage.getItem("is_org_admin") == "true") {
            temp.push({
                navName: "Org Admin Area",
                link: `/organisation/${this.props.match.params.id}/org-admin`
            })
        }
        if(localStorage.getItem("is_success") == "true") {
            temp.push({
                navName: "Super Admin Area",
                link: `/organisation/${this.props.match.params.id}/super-admin`
            })
        }
        this.setState({navData: temp})
    }

    togglereviewQuestionsModal(showModal) {
        this.setState({
            reviewQuestionsModal: true,
            reviewDetails: showModal
        })
    }

    toggleEntireSwotModal(showModal) {
        this.setState({
            reviewQuestionsModal: showModal
        })
    }

    getHtmlTag(text) {
        let splitData = text.split(`\n`)
        const returnData =
            splitData.map(
                (data, i) => {
                    if (data.trim().charAt(0) === '-') {
                        return <li key={i}>{data.trim().substr(1)}</li>
                    }
                    else {
                        return < p key={i} className="mb-1"> {data}</p >
                    }
                }
            )
        return splitData.length > 1 ? returnData : splitData
    }

    actionSelected(data) {
        const fd = {
            "review_question_text": data.data.review_question_text
        }
        this.props.dispatch(superAdminAction.editReviewQuestionsHandler(this.state.reviewDetails.id, this.state.textType, fd, () => {
            this.setState({ updateMessage: true })
        }))
    }

    getContent = (data) => {
        const { getReviewQuestionsResponse } = this.props
        for (let i = 0; i < getReviewQuestionsResponse.length; i++) {
            if (getReviewQuestionsResponse[i].id === data.id) {
                return getReviewQuestionsResponse[i].review_question_text
            }
        }
    }

    render() {
        const { getReviewQuestionsResponse, getReviewQuestionsLoading } = this.props;
        const tables = {
            data: [{
                name: 'Orientation',
                key: 'orientation__orientation_name',
                link: '',
                sort: false,
                type: 'text',
                content: '',
                alignCenter: false,
                headingAlign: false,
                link: ''
            },
            {
                name: 'Text',
                key: 'review_question_text',
                link: '',
                sort: false,
                type: 'text',
                content: '',
                alignCenter: false,
                headingAlign: true,
                link: ''
            }, {
                name: '',
                key: 'EDIT',
                link: '',
                sort: false,
                type: 'iconButton',
                content: 'fa fa-edit fa-custom',
                alignCenter: true,
                link: '',
                title: 'Edit'
            },
            ]
        }

        let tableData = [];
        getReviewQuestionsResponse !== '' &&
            getReviewQuestionsResponse.map(
                (data, i) => {
                    tableData.push({
                        id: data.id,
                        atribute__attribute_name: data.atribute__attribute_name,
                        id: data.id,
                        atribute_id: data.atribute_id,
                        orientation__orientation_name: data.orientation__orientation_name,
                        orientation_id: data.orientation_id,
                        review_question_text: this.getHtmlTag(data.review_question_text),
                    })
                }
            )

        this.state.reviewQuestionsModal &&
            reviewQuestionsContext.map(
                (data, i) => {
                    data.value = this.getContent(this.state.reviewDetails);
                    data.valid = true;
                }
            )

        return (
            <div>
                <Navbar navItems={this.state.navData} backgroundColor="dark" />
                < div className="container-post-nav">
                    <SideNavBar sideNavItems={superAdminAreaData.sideNavCatagoryData} organisationName={localStorage.getItem('orgName')} orgId={this.props.match.params.id} />
                    <div className="main-body-div ">
                        <h5 className="jumbo">REVIEW QUESTIONS - CONTEXT</h5>


                        <TableNew
                            data={tableData}
                            columns={tables.data}
                            onClickEditIcon={this.togglereviewQuestionsModal.bind(this)}
                        />

                        {
                            getReviewQuestionsLoading === true &&
                            <p className="text-center">
                                <i className="fas fa-spinner fa-spin text-dark " ></i>
                                &nbsp;loading
                            </p>
                        }
                        {
                            this.state.reviewQuestionsModal &&
                            <ModalComponent
                                showModal={this.state.reviewQuestionsModal}
                                heading={`Review Questions Context - ${this.state.reviewDetails.orientation__orientation_name}`}
                                formData={reviewQuestionsContext}
                                action={this.actionSelected.bind(this)}
                                toggleEntireModal={this.toggleEntireSwotModal.bind(this)}
                                footerFormSubmitButton={['Save', 'Cancel']}
                            />
                        }

                        {
                            this.state.updateMessage &&
                            <ModalComponent
                                showModal={this.state.updateMessage}
                                heading={`Review Questions Context - ${this.state.reviewDetails.orientation__orientation_name}`}
                                headingIcon="fa fa-check text-white"
                                toggleEntireModal={() => this.setState({ updateMessage: false })}
                                htmlText={`<div className = " text-center">
                                                <p className = "font-weight-bold">Success!</p>
                                                <p>Updated successfully.</p>
                                            </div>`}
                                footerNonSubmitButton={[{
                                    'buttonName': 'Close',
                                }]}
                                responseHandler={(type) => this.setState({ updateMessage: false })}
                            />
                        }
                    </div>
                </div>
            </div>
        )
    }
}



function mapStateToProps(state) {
    const { getReviewQuestionsLoading } = state.getReviewQuestionsReducer;
    const getReviewQuestionsError = state.getReviewQuestionsReducer.error;
    const getReviewQuestionsResponse = (!getReviewQuestionsLoading && !getReviewQuestionsError) ? state.getReviewQuestionsReducer.data.data.review_question_list : '';

    //Header Permission
    const { headPerLoading } = state.headerPermissionReducer
    const headPerLoadingError = state.headerPermissionReducer.error
    const headPerLoadingResonse = (!headPerLoading && !headPerLoadingError) ?  state.headerPermissionReducer.data : '';


    return {
        getReviewQuestionsLoading,
        getReviewQuestionsResponse,
        headPerLoadingResonse,
        headPerLoading,
        headPerLoadingError
    }
}

export default connect(mapStateToProps)(ReviewQuestionsContext);



// WEBPACK FOOTER //
// ./src/_pages/Organzation/SuperAdminArea/ReviewQuestionsContext/index.js